import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { ApiCollectionExportModalComponent } from './components/modals/api-collection-export-modal/api-collection-export-modal.component';
import { VarDirective } from '../../ng-var.directive';
import { GenericTableCellComponent } from './components/snippets/generic-table-cell/generic-table-cell.component';
import { ReportCellComponent } from './components/snippets/report-cell/report-cell.component';
import { CustomerLinkComponent } from './components/snippets/customer-link/customer-link.component';
import { NullableCustomerLinkComponent } from './components/snippets/nullable-customer-link/nullable-customer-link.component';
import { MembershipStatusBadgeComponent } from './components/snippets/membership-status-badge/membership-status-badge.component';
import { PaymentStatusBadgeComponent } from './components/snippets/payment-status-badge/payment-status-badge.component';
// tslint:disable-next-line:max-line-length
import { ReservationsViewToggleComponent } from './components/snippets/reservations-view-toggle/reservations-view-toggle.component';
import {
  CreateSavedReportViewModalComponent
} from './components/modals/saved-report-views/create-saved-report-view-modal/create-saved-report-view-modal.component';
import { CapitanCommonModule } from '../../capitan-common.module';
import { RouterModule } from '@angular/router';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import {
  ViewSavedReportViewsModalComponent
} from './components/modals/saved-report-views/view-saved-report-views-modal/view-saved-report-views-modal.component';
import {
  RenameSavedReportViewModalComponent
} from './components/modals/saved-report-views/rename-saved-report-view-modal/rename-saved-report-view-modal.component';
import {
  SetDefaultReportViewModalComponent
} from './components/modals/saved-report-views/set-default-report-view-modal/set-default-report-view-modal.component';
import {
  SavedReportViewToolbarComponent
} from './components/snippets/saved-report-view-toolbar/saved-report-view-toolbar.component';
import {
  LastUpdatedByFooterComponent
} from './components/snippets/last-updated-by-footer/last-updated-by-footer.component';
import {
  DateRangeFilterComponent
} from './components/snippets/date-range-filter/date-range-filter.component';
import { ColorPickerModule } from 'ngx-color-picker';
import { CapitanColorPickerComponent } from '../../components/color-picker/color-picker.component';
import { ScrollSpyDirective } from '../../scroll-spy.directive';
import { ScrollDetectDirective } from '../../scroll-detect.directive';


@NgModule({
  declarations: [
    ApiCollectionExportModalComponent,
    GenericTableCellComponent,
    ReportCellComponent,
    CustomerLinkComponent,
    NullableCustomerLinkComponent,
    MembershipStatusBadgeComponent,
    PaymentStatusBadgeComponent,
    ReservationsViewToggleComponent,
    CreateSavedReportViewModalComponent,
    ViewSavedReportViewsModalComponent,
    RenameSavedReportViewModalComponent,
    SetDefaultReportViewModalComponent,
    SavedReportViewToolbarComponent,
    LastUpdatedByFooterComponent,
    DateRangeFilterComponent,
    // Declared here rather than in StaffSiteModule so the lazy ReportingModule
    // can use it too (the Chart Builder's per-metric line color, PRO-1369).
    CapitanColorPickerComponent,
    ScrollSpyDirective,
    ScrollDetectDirective,
    VarDirective
  ],
  exports: [
    ApiCollectionExportModalComponent,
    GenericTableCellComponent,
    ReportCellComponent,
    CustomerLinkComponent,
    NullableCustomerLinkComponent,
    MembershipStatusBadgeComponent,
    PaymentStatusBadgeComponent,
    ReservationsViewToggleComponent,
    CreateSavedReportViewModalComponent,
    ViewSavedReportViewsModalComponent,
    RenameSavedReportViewModalComponent,
    SetDefaultReportViewModalComponent,
    SavedReportViewToolbarComponent,
    LastUpdatedByFooterComponent,
    DateRangeFilterComponent,
    CapitanColorPickerComponent,
    ScrollSpyDirective,
    ScrollDetectDirective,
    VarDirective
  ],
  imports: [
    CommonModule,
    FormsModule,
    CapitanCommonModule,
    RouterModule,
    NgbTooltipModule,
    ColorPickerModule,
  ],
})
export class StaffSiteCommonModule {}
